<template>
  <div class="page">
    <HtmlStyleComponent class="page-title" :html="lottery_title" />

    <img v-if="top_image" class="page-top" :src="top_image" alt="top image" />
    <img v-if="logo_image" class="page-logo" :src="logo_image" alt="logo" />
    <HtmlStyleComponent class="page-desc" :html="lottery_detail" />

    <div class="page-buttons">
      <div
        v-for="campaign in campaigns"
        :key="campaign.id"
        class="page-buttons-row"
      >
        <nuxt-link
          v-if="!campaign.finish"
          class="page-buttons-row-item"
          :to="`/event/lottery/campaign/${campaign.id}`"
          :style="{
            backgroundColor: campaign.color
          }"
        >
          {{ campaign.name }}
        </nuxt-link>
        <div v-else class="page-buttons-row-finish">
          {{ campaign.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlStyleComponent from '~/components/molcules/HtmlStyleComponent'

export default {
  components: {
    HtmlStyleComponent
  },
  middleware: ['setAccessToken', 'setCurrentUser'],
  async asyncData({ $eventLotteryRepository, params }) {
    const events = await $eventLotteryRepository.getLottery(params.id)
    return events
  },
  data: () => ({
    lottery_id: undefined,
    lottery_title: undefined,
    lottery_detail: undefined,
    top_image: undefined,
    logo_image: undefined,
    campaigns: []
  })
}
</script>

<style lang="scss" scoped>
.page {
  max-width: 1000px;
  margin: 0 auto 40px;

  &-title {
    margin: 0 16px 24px;
  }

  &-top {
    width: 100%;
    display: block;
    margin-bottom: 32px;
  }

  &-logo {
    max-width: 300px;
    margin: 0 auto;
    display: block;
    width: 50%;
    margin-bottom: 32px;
  }

  &-desc {
    margin-bottom: 48px;
    text-align: center;
    font-size: 14px;
    color: #333333;
  }

  &-buttons {
    padding: 0 16px;
    &-row {
      margin-bottom: 16px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
      &-item {
        display: block;
        text-decoration: none;
        padding: 8px 16px;
        color: white;
        border-radius: 4px;
        text-align: center;
        font-weight: 600;
      }

      &-finish {
        background-color: lightgray;
        padding: 8px 16px;
        color: white;
        border-radius: 4px;
        text-align: center;
        font-weight: 600;
      }
    }
  }
}
</style>
